import { gql } from "@apollo/client";

export const GET_VARIABLE = gql`
    query refs($className: String!, $query: JSON!, $offset: Int, $limit: Int) {
        configurationItems(className: $className, query: $query, take: $limit, offset: $offset) {
            sysId
            name
        }
    }
`;
